// File: src/lib/constants.ts
// Purpose: Application constants for InstaDev
// InstaDev - Constants

export const APP_NAME = 'InstaDev'
export const APP_TAGLINE = 'Innovative Development Solutions'
export const APP_VERSION = '1.0.0'

export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1'

export const STORAGE_KEYS = {
  THEME: 'insatdev-theme',
  SIDEBAR_STATE: 'insatdev-sidebar-collapsed',
  RECENT_SEARCHES: 'insatdev-recent-searches',
  USER_PREFERENCES: 'insatdev-user-preferences',
} as const

export const QUERY_KEYS = {
  USER: 'user',
  USERS: 'users',
  PROJECTS: 'projects',
  ANALYTICS: 'analytics',
  NOTIFICATIONS: 'notifications',
} as const

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/',
  ANALYTICS: '/analytics',
  PROJECTS: '/projects',
  USERS: '/users',
  SETTINGS: '/settings',
  NOTIFICATIONS: '/notifications',
} as const

export const BREAKPOINTS = {
  SM: 640,
  MD: 768,
  LG: 1024,
  XL: 1280,
  '2XL': 1536,
} as const

export const DIMENSIONS = {
  HEADER_HEIGHT: 56,
  SIDEBAR_WIDTH_EXPANDED: 260,
  SIDEBAR_WIDTH_COLLAPSED: 64,
  CONTENT_MAX_WIDTH: 1440,
} as const

export const ANIMATION_DURATION = {
  FAST: 150,
  BASE: 200,
  SLOW: 300,
  SLOWER: 500,
} as const

export const Z_INDEX = {
  DROPDOWN: 10,
  SIDEBAR: 20,
  HEADER: 30,
  MODAL_BACKDROP: 40,
  MODAL: 50,
  NOTIFICATION: 60,
  TOOLTIP: 70,
} as const

export const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  VIEWER: 'viewer',
} as const

export const PROJECT_STATUS = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  COMPLETED: 'completed',
  ARCHIVED: 'archived',
} as const